export function getMeetingTopicCode(meeting) {
  return String(
    meeting?.activityGroup?.code || meeting?.activity_group?.code ||
    meeting?.group?.code || meeting?.group_code || meeting?.groupCode ||
    meeting?.school?.code || ''
  ).trim();
}

export function getMeetingTopicMaxLength(code) {
  return Math.max(0, 255 - (code ? code.length + 3 : 0));
}

export function formatMeetingTopic(meeting) {
  const topic = String(meeting?.topic || '').trim();
  const code = getMeetingTopicCode(meeting);
  return topic && code ? `${topic} - ${code}` : topic;
}
